import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PaginationComponent } from "../component/PaginationComponent";
import Actions from "../Redux/action"
import { onboardingData, onboardingStaffData } from "../Redux/reducer/OnboardingList";
import { toast } from "react-toastify";
import { Search } from "../component/Search";
import AppLoader from "../component/AppLoader";
import { BASE_URL, IMAGE_URL } from "../Redux/saga/EndPoints";
import EndPoints from "../Redux/saga/EndPoints";
import { doPostFormData } from "../service";
import nodatafound from '../asset/img/datanotfound_black.png';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import ExcelJS from 'exceljs';
import Placeholder from '../asset/img/no-preview.png';
import { DeclinePopup } from "../component/DeclinePopup";
import AlertGeneratePsswordModal from "./AlertGeneratePasswordModal";
import { getCollegeList, getCourseList, getSectionList, getSelectedData, getYearList, getdepartmentList, getdepartmentSearch } from "../Redux/reducer/SchedulerReducer";
import { searchList } from "../Redux/reducer/SearchList";
import CourseTypehead from "../component/CourseTypehead";
import DepartmentTypehead from "../component/DepartmentTypehead";
import Select from "react-select";
import { getHostelListSelectSelector, getHostelListSelector, getHostellerListSelector } from "../Redux/reducer/HostelReducer";
import { getUserData } from "../Redux/reducer/LoginReducer";


export const OnboardingList = () => {
  const parent_name = "Parent";
  const parent_mail = "Parent@gmail.com";
  const EXCEL_EXTENSION = '.xlsx'
  const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const [isApprovalLoading, setIsApprovalLoading] = useState(false);
  const [currentVideoItem, setCurrentVideoItem] = useState(null);
  const [rejectRemarks, setRejectRemarks] = useState('');
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [isLoadingVideo, setIsLoadingVideo] = useState(false);
  const dispatch = useDispatch();
  const [editVideoFile, setEditVideoFile] = useState(null);
  const [editVideoPreview, setEditVideoPreview] = useState(null);
  const [isUploadingVideo, setIsUploadingVideo] = useState(false);
  const user = useSelector(getUserData)
  const [pageNumber, setPageNumber] = useState(1)
  const onboardedList = useSelector(onboardingData)
  const onboardedStaffList = useSelector(onboardingStaffData)
  const [isloading, setLoading] = useState(false)
  const [count, setcount] = useState();
  const [alertGenPasswordModal, setAlertGetPasswordModal] = useState(false)
  const [isSearch, onSearch] = useState(false);
  const [user_name, setUserName] = useState('');
  const collegeList = useSelector(getCollegeList)
  const courseList = useSelector(getCourseList)
  const hostelList = useSelector(getHostelListSelectSelector)
  const departmentList = useSelector(getdepartmentList)

  const yearList = useSelector(getYearList)
  const sectionList = useSelector(getSectionList);
  const searchData = useSelector(searchList);
  const selctedFormData = useSelector(getSelectedData);
  const [formDetails, setFormDetails] = useState({});
  const tabValue = (user?.user_type === '5' || user?.user_type === '6') ? 2 : 1
  const [tab, setTab] = useState(tabValue)
  const [isOpenDeclineModal, setOpenDeclineModal] = useState(false);
  const [showList, setShowList] = useState(false);
  const [searchvalue, setvalue] = useState('');
  const [itemObj, setItemObj] = useState('');
  const [hostelId, setHostelId] = useState();
  const hostellerList = useSelector(getHostellerListSelector)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddUserModalOpen, setAddUserModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [personType, setPersonType] = useState('');
  const [sectionIdInput, setSectionIdInput] = useState('');
  const [hostellerSortColumn, setHostellerSortColumn] = useState(null);
  const [hostellerSortDirection, setHostellerSortDirection] = useState('asc');
  const [toggleConfirmPending, setToggleConfirmPending] = useState(null);
  const excelUploadRef = useRef(null);
  const downloadDropdownRef = useRef(null);
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);
  const [uploadExcelLoading, setUploadExcelLoading] = useState(false);
  const [newPersonForm, setNewPersonForm] = useState({
    name: '',
    member_id: '',
    college_id: '',
    department_id: '',
    course_id: '',
    course: '',
    department: '',
    section_id: '',
    hostel_id: '',
    is_active: true,
    person_category: '',
    videoFile: null,
    videoPreview: null,
    email: '',
    gender: 'M',
    year_from: '',
    year_to: '',
    has_24_7_access: false
  });

  const getRoleLabel = (subjectType) => {
    if (subjectType == null || subjectType === undefined) return 'Staff';
    const s = String(subjectType);
    if (s === '0') return 'Admin';
    if (s === '1' || s === '3') return 'Staff';
    if (s === '2') return 'Student';
    if (s === '4') return 'Supervisor';
    return 'Staff';
  };

  const handleHostellerSort = (column) => {
    if (hostellerSortColumn === column) {
      setHostellerSortDirection((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setHostellerSortColumn(column);
      setHostellerSortDirection('asc');
    }
  };

  const HostellerSortableHeader = ({ column, label }) => (
    <th
      className="border-0 text-center cursor-pointer user-select-none"
      onClick={() => handleHostellerSort(column)}
      style={{ cursor: 'pointer' }}
    >
      {label}
      {hostellerSortColumn === column ? (
        <i className={`fas fa-sort-${hostellerSortDirection === 'asc' ? 'up' : 'down'} ms-1`} />
      ) : (
        <i className="fas fa-sort ms-1 text-muted" style={{ opacity: 0.5 }} />
      )}
    </th>
  );

  const fetchVideoUrl = (memberId) => {
    setIsLoadingVideo(true);
    const params = {
      member_id: memberId,
    };

    const callback = (response) => {
      setIsLoadingVideo(false);
      if (response?.status_code === 0 && response?.response) {
        setVideoUrl(response.response);
      } else {
        toast.error(response?.message || "Video not found");
        setVideoUrl('');
      }
    };

    dispatch(Actions.getPersonVideoRequest(params, callback));
  };

  const handleViewVideo = (memberId, item) => {
    setSelectedMemberId(memberId);
    setVideoModalOpen(true);
    setCurrentVideoItem(item); // Store the item data
    fetchVideoUrl(memberId);
  };
  const hosteller_update = (data, newVideoFile = null) => {
    setLoading(true);

    if (newVideoFile) {
      // If there's a new video file, use FormData
      const formData = new FormData();

      // Add all the update data
      formData.append('id', data?.id);
      formData.append('name', data?.name || '');
      formData.append('member_id', data?.member_id || '');
      formData.append('is_active', data?.is_active ? '1' : '0');
      if (data?.subject_type === '2') {
        formData.append('has_24_7_access', data?.has_24_7_access ? '1' : '0');
      }
      if (data?.room_number !== undefined) {
        formData.append('room_number', data?.room_number || '');
      }

      // Add the video file
      formData.append('video', newVideoFile);
      formData.append('reupload_video', '1'); // Flag to indicate video re-upload

      const callback = (response) => {
        setLoading(false);
        onCloseModel();
        if (response?.status_code === 0) {
          toast.success("Video re-uploaded successfully!");

          // Refresh the list
          const refetchParams = {
            page: pageNumber,
            searching_text: searchvalue,
            college_id: formDetails?.college_id,
            hostel_id: hostelId,
            ...(hostellerSortColumn && { sort_by: hostellerSortColumn, sort_order: hostellerSortDirection }),
          };
          const refetchCallback = (res) => {
            setcount(res?.count);
            handleCloseModal();
          };
          dispatch(Actions.hostellerList(refetchParams, refetchCallback));
        } else {
          toast.error(response?.message || "Failed to re-upload video");
        }
      };

      // Call the update API with FormData for video upload
      dispatch(Actions.editHostellerRequest(formData, callback));

    } else {
      // Regular update without video (existing functionality)
      const params = {
        id: data?.id,
        name: data?.name,
        member_id: data?.member_id,
        room_number: data?.room_number || null,
        is_active: data?.is_active ? 1 : 0,
      };
      if (data?.subject_type === '2') {
        params.has_24_7_access = data?.has_24_7_access ? '1' : '0';
      }

      const callback = (response) => {
        setLoading(false);
        onCloseModel();
        if (response?.status_code === 0) {
          toast.success("Updated Successfully");
          handleCloseModal();
          const refetchParams = {
            page: pageNumber,
            searching_text: searchvalue,
            college_id: formDetails?.college_id,
            hostel_id: hostelId,
            ...(hostellerSortColumn && { sort_by: hostellerSortColumn, sort_order: hostellerSortDirection }),
          };
          const refetchCallback = (res) => {
            setcount(res?.count);
          };
          dispatch(Actions.hostellerList(refetchParams, refetchCallback));
        } else {
          toast.error(response?.message || "Something went wrong");
        }
      };

      dispatch(Actions.editHostellerRequest(params, callback));
    }
  };
  const handleEditVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.includes('video/')) {
        toast.error('Please upload a video file');
        return;
      }

      if (file.size > 100 * 1024 * 1024) {
        toast.error('Video file size should be less than 100MB');
        return;
      }

      setEditVideoFile(file);
      setEditVideoPreview(URL.createObjectURL(file));
    }
  };

  const removeEditVideo = () => {
    if (editVideoPreview) {
      URL.revokeObjectURL(editVideoPreview);
    }
    setEditVideoFile(null);
    setEditVideoPreview(null);
  };
  const handleEdit = (item) => {
    if (editVideoPreview) {
      URL.revokeObjectURL(editVideoPreview);
    }

    setEditItem({
      ...item,
      has_24_7_access: item?.has_24_7_access ?? !item?.is_restricted_access,
    });
    setEditVideoFile(null);
    setEditVideoPreview(null);
    setIsEditModalOpen(true);
  };

  const handleReuploadVideo = () => {
    if (!editVideoFile) {
      toast.error('Please select a video file');
      return;
    }

    hosteller_update(editItem, editVideoFile);
  };
  const handleAddPersonSubmit = () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const formData = new FormData();

    formData.append('name', newPersonForm.name.trim());
    formData.append('member_id', newPersonForm.member_id.trim());
    formData.append('gender', newPersonForm.gender);
    formData.append('has_24_7_access', newPersonForm.has_24_7_access ? '1' : '0');
    formData.append('is_active', newPersonForm.is_active ? '1' : '0');
    formData.append('hostel_id', newPersonForm.hostel_id);
    formData.append('person_type', personType === 'student' ? '0' : '1');
    formData.append('email', newPersonForm.email.trim());

    if (personType === 'student') {
      formData.append('college_id', newPersonForm.college_id || '');
      formData.append('course_id', newPersonForm.course || '');
      formData.append('department_id', newPersonForm.department || '');
      formData.append('year_from', newPersonForm.year_from || '');
      formData.append('year_to', newPersonForm.year_to || '');
      formData.append('person_category', 'student');
      formData.append('parent_name', parent_name);
      formData.append('parent_mail', parent_mail);
    } else {
      formData.append('person_category', newPersonForm.person_category || '');
    }

    if (newPersonForm.videoFile instanceof File) {
      formData.append('video', newPersonForm.videoFile);

    } else {
      toast.error('Please select a valid video file');
      setLoading(false);
      return;
    }

    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}: File(${value.name}, ${value.size} bytes, ${value.type})`);
      } else {
        console.log(`${key}: ${value}`);
      }
    }

    const callback = (response) => {
      setLoading(false);
      if (response?.status_code === 0) {
        toast.success("Person added successfully!");
        setAddUserModalOpen(false);
        restoreMainPageLists();

        // Reset form
        setNewPersonForm({
          name: '',
          member_id: '',
          college_id: '',
          department_id: '',
          course_id: '',
          course: '',
          department: '',
          section_id: '',
          hostel_id: '',
          is_active: true,
          person_category: '',
          videoFile: null,
          videoPreview: null,
          email: '',
          gender: 'M',
          year_from: '',
          year_to: '',
          has_24_7_access: false
        });
        setPersonType('');

        if (newPersonForm.videoPreview) {
          URL.revokeObjectURL(newPersonForm.videoPreview);
        }

        DepartmentSearch();
      } else {
        toast.error(response?.message || "Failed to add person");
      }
    };

    dispatch(Actions.addNewPersonRequest(formData, callback));
  };

  const validateForm = () => {
    if (!newPersonForm.name.trim()) {
      toast.error("Name is required");
      return false;
    }
    if (!newPersonForm.member_id.trim()) {
      toast.error("Member ID is required");
      return false;
    }
    if (!newPersonForm.videoFile) {
      toast.error("Video is required for face recognition");
      return false;
    }
    if (!newPersonForm.hostel_id) {
      toast.error("Hostel selection is required");
      return false;
    }
    if (personType === 'student') {
      if (!newPersonForm.college_id) {
        toast.error("College is required");
        return false;
      }
      if (!newPersonForm.course_id) {
        toast.error("Course is required");
        return false;
      }
      if (!newPersonForm.department_id) {
        toast.error("Department is required");
        return false;
      }
      if (!newPersonForm.year_from || !newPersonForm.year_to) {
        toast.error("Year From and Year To are required");
        return false;
      }
    }
    return true;
  };

  const handleCloseModal = () => {
    if (editVideoPreview) {
      URL.revokeObjectURL(editVideoPreview);
    }

    setIsEditModalOpen(false);
    setEditItem(null);
    setEditVideoFile(null);
    setEditVideoPreview(null);
    setIsUploadingVideo(false);
    setSectionIdInput(null);
  };
  const handleAddNewPerson = () => {
    setAddUserModalOpen(true);

  };
  const onChangeHandle = (pageNumber) => {
    setPageNumber(pageNumber)
  }
  const DepartmentSearch = useCallback(() => {
    setLoading(true)
    const callback = (res) => {
      setcount(res?.count)
      setLoading(false)
    }
    let params = {
      page: pageNumber,
      searching_text: searchvalue,
      college_id: formDetails?.college_id,
    }
    if (tab === 1) {
      params['course_id'] = formDetails?.course_id
      params['year_id'] = formDetails?.year_id
      params['department_id'] = formDetails?.department_id
      params['section_id'] = formDetails?.section_id
    } else {
      params['hostel_id'] = hostelId
      if (hostellerSortColumn) {
        params['sort_by'] = hostellerSortColumn
        params['sort_order'] = hostellerSortDirection
      }
    }
    tab === 1 ? dispatch(Actions.onboardingAction(params, callback))
      : dispatch(Actions.hostellerList(params, callback))
  }, [dispatch, formDetails?.college_id, formDetails?.course_id, formDetails?.department_id, formDetails?.year_id, formDetails?.section_id, tab, pageNumber, hostelId, hostellerSortColumn, hostellerSortDirection])

  useEffect(() => {
    DepartmentSearch()
  }, [dispatch, formDetails?.college_id, formDetails?.course_id, formDetails?.department_id, formDetails?.year_id, formDetails?.section_id, tab, pageNumber, hostelId, hostellerSortColumn, hostellerSortDirection])

  // useEffect(()=>{
  //   dispatch(Actions.)
  // },[])

  useEffect(() => {
    dispatch(Actions.CollegeListAction())
  }, [dispatch])

  useEffect(() => {
    if (tab === 1) {
      const params = {
        id: formDetails?.college_id
      }
      dispatch(Actions.CoursetAction(params))
    }
  }, [dispatch, formDetails?.college_id])

  useEffect(() => {
    if (tab === 1) {
      const params = {
        id: formDetails?.course_id
      }
      dispatch(Actions.DepartmentAction(params))
    }
  }, [dispatch, formDetails?.course_id])

  useEffect(() => {
    if (tab === 1) {
      const params = {
        id: formDetails?.department_id
      }
      dispatch(Actions.YearAction(params))
    }
  }, [dispatch, formDetails?.department_id])

  useEffect(() => {
    setHostelId('')
    let params = {
      college_id: formDetails?.college_id
    }
    dispatch(Actions.hostelListSelect(params))
  }, [dispatch, formDetails?.college_id])

  useEffect(() => {
    if (tab === 1) {
      const params = {
        id: formDetails?.department_id,
        year: formDetails?.year_id
      }
      dispatch(Actions.SectiontAction(params))
    }
  }, [dispatch, formDetails?.year_id])

  // Load college list when Add Student modal is open (for College dropdown)
  useEffect(() => {
    if (isAddUserModalOpen && personType === 'student') {
      dispatch(Actions.CollegeListAction())
    }
  }, [dispatch, isAddUserModalOpen, personType])

  const restoreMainPageLists = useCallback(() => {
    if (tab !== 1) return;
    if (formDetails?.college_id) dispatch(Actions.CoursetAction({ id: formDetails.college_id }));
    if (formDetails?.course_id) dispatch(Actions.DepartmentAction({ id: formDetails.course_id }));
    if (formDetails?.department_id) dispatch(Actions.YearAction({ id: formDetails.department_id }));
    if (formDetails?.department_id && formDetails?.year_id) {
      dispatch(Actions.SectiontAction({ id: formDetails.department_id, year: formDetails.year_id }));
    }
  }, [dispatch, tab, formDetails?.college_id, formDetails?.course_id, formDetails?.department_id, formDetails?.year_id])

  const confirmToggleStatus = () => {
    if (toggleConfirmPending) {
      updateStatus(toggleConfirmPending.id, toggleConfirmPending.active);
      setToggleConfirmPending(null);
    }
  };

  const updateStatus = (id, active) => {
    const updateParams = {
      id,
      is_active: !active,
    }
    let params = {
      page: pageNumber,
      searching_text: searchvalue,
      college_id: formDetails?.college_id,
    }
    if (tab === 1) {
      params['course_id'] = formDetails?.course_id
      params['department_id'] = formDetails?.department_id
      params['year_id'] = formDetails?.year_id
      params['section_id'] = formDetails?.section_id
      params['person_type'] = 0
    } else {
      params['hostel_id'] = hostelId
      params['person_type'] = 1
      if (hostellerSortColumn) {
        params['sort_by'] = hostellerSortColumn
        params['sort_order'] = hostellerSortDirection
      }
    }
    setLoading(true)
    const callback = (response) => {
      const onboardCallback = () => {
        setLoading(false)
      }
      if (response.status_code === 0) {
        toast.success(!active ? "Enabled Successfully" : "Disabled Successfully")
        setLoading(false)
        tab === 1 ? dispatch(Actions.onboardingAction(params, onboardCallback())) : dispatch(Actions.hostellerList(params, onboardCallback()))
      }
      else {
        setLoading(false)
        toast.error(response.response_message)
      }
    }
    tab === 1 ? dispatch(Actions.toggleAction(updateParams, callback)) : dispatch(Actions.toggleHostellerAction(updateParams, callback))
  }
  const hosteller_delete = (member_id) => {
    setLoading(true)
    const params = {
      person_id: member_id,
    }
    if (tab === 1) {
      params['person_type'] = 0
    } else {
      params['person_type'] = 1
    }
    const callback = (res) => {
      if (res?.status_code === 0) {
        // setLoading(false)
        // let params = {
        //     page: pageNumber ?? 1
        // }
        let params = {
          page: pageNumber ?? 1,
          searching_text: searchvalue,
          college_id: formDetails?.college_id,
        }
        if (tab === 1) {
          params['course_id'] = formDetails?.course_id
          params['department_id'] = formDetails?.department_id
          params['year_id'] = formDetails?.year_id
          params['section_id'] = formDetails?.section_id
          params['person_type'] = 0
        } else {
          params['hostel_id'] = hostelId
          params['person_type'] = 1
          if (hostellerSortColumn) {
            params['sort_by'] = hostellerSortColumn
            params['sort_order'] = hostellerSortDirection
          }
        }
        const callback = (response) => {
          setLoading(false)
          onCloseModel()
          if (response) {
            setLoading(false)
            toast.success("Deleted Successfully")
            setcount(response?.count)
            // getOnboardList()
          }
          else {
            setLoading(false)
            toast.error("Something went worng")
          }
        }

        tab === 1 ? dispatch(Actions.onboardingAction(params, callback))
          : dispatch(Actions.hostellerList(params, callback))
      } else {
        setLoading(false)
        toast.error(res?.message)
      }
    }
    dispatch(Actions.deleteMember(params, callback))
  }
  const deleteMember = () => {
    setLoading(true)
    const params = {
      person_id: itemObj?.member_id,
    }
    if (tab === 1) {
      params['person_type'] = 0
    } else {
      params['person_type'] = 1
    }
    const callback = (res) => {
      if (res?.status_code === 0) {
        // setLoading(false)
        // let params = {
        //     page: pageNumber ?? 1
        // }
        let params = {
          page: pageNumber ?? 1,
          searching_text: searchvalue,
          college_id: formDetails?.college_id,
        }
        if (tab === 1) {
          params['course_id'] = formDetails?.course_id
          params['department_id'] = formDetails?.department_id
          params['year_id'] = formDetails?.year_id
          params['section_id'] = formDetails?.section_id
          params['person_type'] = 0
        } else {
          params['hostel_id'] = hostelId
          params['person_type'] = 1
          if (hostellerSortColumn) {
            params['sort_by'] = hostellerSortColumn
            params['sort_order'] = hostellerSortDirection
          }
        }
        const callback = (response) => {
          setLoading(false)
          onCloseModel()
          if (response) {
            setLoading(false)
            toast.success("Deleted Successfully")
            setcount(response?.count)
            // getOnboardList()
          }
          else {
            setLoading(false)
            toast.error("Something went worng")
          }
        }

        tab === 1 ? dispatch(Actions.onboardingAction(params, callback))
          : dispatch(Actions.hostellerList(params, callback))
      } else {
        setLoading(false)
        toast.error(res?.message)
      }
    }
    dispatch(Actions.deleteMember(params, callback))
  }

  const handleVideoApproval = (action) => {
    if (!currentVideoItem || !selectedMemberId) return;

    setIsApprovalLoading(true);
    // if (!sectionIdInput.trim()) {
    //   toast.error('Please enter Section ID before proceeding');
    //   return;
    // }

    const params = {
      member_id: selectedMemberId,
      status: action === 'accept' ? 2 : 1,
      remarks: action === 'reject' ? rejectRemarks : '',
      section_id: sectionIdInput || ''
    };

    const callback = (response) => {
      setIsApprovalLoading(false);

      if (response?.status_code === 0) {
        toast.success(`Video ${action === 'accept' ? 'accepted' : 'rejected'} successfully`);

        // Refresh the list
        const refetchParams = {
          page: pageNumber,
          searching_text: searchvalue,
          college_id: formDetails?.college_id,
          hostel_id: hostelId,
          ...(hostellerSortColumn && { sort_by: hostellerSortColumn, sort_order: hostellerSortDirection }),
        };

        const refetchCallback = (res) => {
          setcount(res?.count);
        };

        dispatch(Actions.hostellerList(refetchParams, refetchCallback));

        // Close modals
        setShowRejectModal(false);
        setSectionIdInput('');

        setVideoModalOpen(false);
        setRejectRemarks('');
      } else {
        toast.error(response?.message || `Failed to ${action} video`);
      }
    };

    dispatch(Actions.sendApprovalRequest(params, callback));
  };

  const handleRejectClick = () => {
    setShowRejectModal(true);
  };
  const handleRejectSubmit = () => {
    if (!rejectRemarks.trim()) {
      toast.error('Please provide remarks for rejection');
      return;
    }

    handleVideoApproval('reject');
    setSectionIdInput('');
  };
  const onCloseModel = () => {
    setItemObj('');
    setOpenDeclineModal(false)
  };
  const handleVideoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.includes('video/')) {
        toast.error('Please upload a video file');
        return;
      }

      if (file.size > 100 * 1024 * 1024) {
        toast.error('Video file size should be less than 100MB');
        return;
      }

      setNewPersonForm({
        ...newPersonForm,
        videoFile: file,
        videoPreview: URL.createObjectURL(file)
      });
    }
  };

  const removeVideo = () => {
    if (newPersonForm.videoPreview) {
      URL.revokeObjectURL(newPersonForm.videoPreview);
    }
    setNewPersonForm({
      ...newPersonForm,
      videoFile: null,
      videoPreview: null
    });
  };
  const openGeneratPasswordeAlert = (data) => {
    setUserName(data)
    setAlertGetPasswordModal(true)
  }
  const handleClick = (item) => {
    setItemObj(item);
    setOpenDeclineModal(true);
  };
  const handleCollegeSelect = (selected) => {
    setFormDetails({ ...formDetails, 'course_id': '', 'year_id': '', 'department_id': '', 'section_id': '', 'college_id': selected })
  };
  const handleDepartmentSelect = (selected) => {
    setFormDetails({ ...formDetails, 'year_id': '', 'department_id': selected, 'section_id': '' })
  };
  const handleCourseSelect = (selected) => {
    setFormDetails({ ...formDetails, 'department_id': '', 'course_id': selected, 'section_id': '', 'year_id': '' })
  };
  const handleYearSelect = (selected) => {
    setFormDetails({ ...formDetails, 'year_id': selected, 'section_id': '' })
  };
  const handleSectionSelect = (selected) => {
    setFormDetails({ ...formDetails, 'section_id': selected })
  };
  const url = IMAGE_URL.replace(/\/$/, '');
  const handleTab = (tab) => {
    if (user?.user_type === "5") {
      return
    }
    setPageNumber(1)
    setTab(tab)
    setvalue("")
    setFormDetails({ college_id: "" })
    setShowList(false)
    setHostelId("")
  }
  const handleOnchangeSearch = (event) => {
    const callback = (response) => {
      dispatch(Actions.onboardingSearchAction(response))
      setLoading(false)
    }
    const callBack = (response) => {
      setcount(response?.count)
      dispatch(Actions.searchSuccessAction(response))
      setLoading(false)
      onSearch(false)
      setPageNumber(1)
    }
    if ((event.target.value)?.length >= 3) {
      setShowList(true)
      onSearch(true)
      let params = {
        searching_text: event.target.value,
        college_id: formDetails?.college_id,
      }
      if (tab === 1) {
        params['course_id'] = formDetails?.course_id
        params['department_id'] = formDetails?.department_id
        params['year_id'] = formDetails?.year_id
        params['section_id'] = formDetails?.section_id
        params['person_type'] = 0
      } else {
        params['hostel_id'] = hostelId
        params['person_type'] = 1
        if (hostellerSortColumn) {
          params['sort_by'] = hostellerSortColumn
          params['sort_order'] = hostellerSortDirection
        }
      }
      setLoading(true)
      dispatch(Actions.searchAction(params, callback));
      dispatch(Actions.hostellerList(params, callBack))
    } else if ((event.target.value)?.length === 0) {
      setShowList(true)
      let params = {
        page: 1,
        searching_text: event?.target?.value,
        college_id: formDetails?.college_id,
      }
      if (tab === 1) {
        params['course_id'] = formDetails?.course_id
        params['department_id'] = formDetails?.department_id
        params['year_id'] = formDetails?.year_id
        params['section_id'] = formDetails?.section_id
        params['person_type'] = 0
      } else {
        params['hostel_id'] = hostelId
        params['person_type'] = 1
        if (hostellerSortColumn) {
          params['sort_by'] = hostellerSortColumn
          params['sort_order'] = hostellerSortDirection
        }
      }
      setLoading(true)
      tab === 1 ? dispatch(Actions.onboardingAction(params, callBack))
        : dispatch(Actions.hostellerList(params, callBack))
    }
    else {
      setShowList(false)
    }
    setvalue(event.target.value)
  }
  const Onsearch = (serachProduct) => {
    const callback = (response) => {
      dispatch(Actions.onboardingSearchAction(response))
      setLoading(false)
    }
    setShowList(false)
    setLoading(true)
    // setvalue(serachProduct)
    let params = {
      id: serachProduct
    }
    dispatch(Actions.searchListAction(params, callback))
  }

  const fetchImageAsBase64 = (imageUrl) => {
    return fetch(imageUrl, { credentials: 'omit', mode: 'cors' })
      .then((res) => (res.ok ? res.blob() : Promise.reject(new Error('Failed to load image'))))
      .then((blob) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            const dataUrl = reader.result;
            const base64 = dataUrl.indexOf(',') >= 0 ? dataUrl.split(',')[1] : dataUrl;
            resolve({ base64, isPng: blob.type === 'image/png' });
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      })
      .catch(() => null);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (downloadDropdownRef.current && !downloadDropdownRef.current.contains(e.target)) {
        setShowDownloadDropdown(false);
      }
    };
    if (showDownloadDropdown) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showDownloadDropdown]);

  const handleDownload = () => {
    if (!hostelId) {
      toast.warning('Please select college and hostel');
      setShowDownloadDropdown(false);
      return;
    }
    setShowDownloadDropdown(false);
    const saveAsExcelFile = (buffer, fileName) => {
      const data = new Blob([buffer], { type: EXCEL_TYPE }) || [];
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    };
    const callback = async (response) => {
      if (!response?.results?.length) {
        toast.error("Something went worng");
        setLoading(false);
        return;
      }
      const baseUrl = IMAGE_URL.replace(/\/$/, '');
      const IMAGE_ROW_HEIGHT = 56;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('data', { views: [{ rightToLeft: false }] });
      worksheet.columns = [
        { header: 'S.No', key: 'sno', width: 6 },
        { header: 'Image', key: 'image', width: 12 },
        { header: 'Name', key: 'name', width: 18 },
        { header: 'Person ID', key: 'personId', width: 14 },
        { header: 'Role', key: 'role', width: 10 },
        { header: 'Course', key: 'course', width: 18 },
        { header: 'Department', key: 'department', width: 18 },
        { header: 'Joining Year', key: 'joiningYear', width: 12 },
        { header: 'Onboarding status', key: 'onboardingStatus', width: 18 },
        { header: 'Status', key: 'status', width: 10 },
      ];
      worksheet.getRow(1).font = { bold: true };
      const results = response.results;
      for (let i = 0; i < results.length; i++) {
        const item = results[i];
        const excelRow = i + 2;
        worksheet.addRow({
          sno: i + 1,
          image: '',
          name: item?.name ?? '',
          personId: item?.member_id ?? '',
          role: item?.role ?? getRoleLabel(item?.subject_type),
          course: item?.course ?? '',
          department: item?.department ?? '',
          joiningYear: item?.joining_year ?? '',
          onboardingStatus: item?.onboarding_status === 0
            ? 'Not Approved'
            : item?.onboarding_status === 1
              ? 'Rejected'
              : 'Accepted',
          status: item?.is_active ? 'Active' : 'Inactive',
        });
        worksheet.getRow(excelRow).height = IMAGE_ROW_HEIGHT;
      }
      toast.info('Embedding images...');
      for (let i = 0; i < results.length; i++) {
        const item = results[i];
        if (!item?.img_url) continue;
        const fullUrl = baseUrl + (item.img_url.startsWith('/') ? '' : '/') + item.img_url;
        const imageData = await fetchImageAsBase64(fullUrl);
        if (!imageData?.base64) continue;
        try {
          const imageId = workbook.addImage({
            extension: imageData.isPng ? 'png' : 'jpeg',
            base64: imageData.base64,
          });
          const excelRow = i + 2;
          worksheet.addImage(imageId, {
            tl: { col: 1, row: excelRow - 1 },
            ext: { width: 48, height: 48 },
          });
        } catch (_) {}
      }
      const buffer = await workbook.xlsx.writeBuffer();
      saveAsExcelFile(buffer, 'Report');
      toast.success("Downloaded Successfully");
      setLoading(false);
    };
    const params = {
      college_id: formDetails?.college_id,
      hostel_id: hostelId,
      page: 1,
      page_size: 10000,
      ...(hostellerSortColumn && { sort_by: hostellerSortColumn, sort_order: hostellerSortDirection }),
    };
    setLoading(true);
    dispatch(Actions.hostellerList(params, callback));
  };

  const handleDownloadWithoutImage = () => {
    if (!hostelId) {
      toast.warning('Please select college and hostel');
      setShowDownloadDropdown(false);
      return;
    }
    setShowDownloadDropdown(false);
    const saveAsExcelFile = (buffer, fileName) => {
      const data = new Blob([buffer], { type: EXCEL_TYPE }) || [];
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    };
    const callback = async (response) => {
      if (!response?.results?.length) {
        toast.error("Something went wrong");
        setLoading(false);
        return;
      }
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('data', { views: [{ rightToLeft: false }] });
      worksheet.columns = [
        { header: 'S.No', key: 'sno', width: 6 },
        { header: 'Name', key: 'name', width: 18 },
        { header: 'Person ID', key: 'personId', width: 14 },
        { header: 'Role', key: 'role', width: 10 },
        { header: 'Course', key: 'course', width: 18 },
        { header: 'Department', key: 'department', width: 18 },
        { header: 'Joining Year', key: 'joiningYear', width: 12 },
        { header: 'Onboarding status', key: 'onboardingStatus', width: 18 },
        { header: 'Status', key: 'status', width: 10 },
      ];
      worksheet.getRow(1).font = { bold: true };
      const results = response.results;
      for (let i = 0; i < results.length; i++) {
        const item = results[i];
        worksheet.addRow({
          sno: i + 1,
          name: item?.name ?? '',
          personId: item?.member_id ?? '',
          role: item?.role ?? getRoleLabel(item?.subject_type),
          course: item?.course ?? '',
          department: item?.department ?? '',
          joiningYear: item?.joining_year ?? '',
          onboardingStatus: item?.onboarding_status === 0
            ? 'Not Approved'
            : item?.onboarding_status === 1
              ? 'Rejected'
              : 'Accepted',
          status: item?.is_active ? 'Active' : 'Inactive',
        });
      }
      const buffer = await workbook.xlsx.writeBuffer();
      saveAsExcelFile(buffer, 'Report_no_image');
      toast.success("Downloaded Successfully");
      setLoading(false);
    };
    const params = {
      college_id: formDetails?.college_id,
      hostel_id: hostelId,
      page: 1,
      page_size: 10000,
      ...(hostellerSortColumn && { sort_by: hostellerSortColumn, sort_order: hostellerSortDirection }),
    };
    setLoading(true);
    dispatch(Actions.hostellerList(params, callback));
  };

  const handleDownloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const studentsHeaders = ['member_id', 'name', 'gender', 'hostel_id', 'is_restricted', 'email', 'course', 'department', 'year_from', 'year_to'];
    const staffHeaders = ['member_id', 'name', 'gender', 'hostel_id', 'is_restricted', 'email'];
    const studentsSheet = workbook.addWorksheet('Students', { views: [{ rightToLeft: false }] });
    studentsSheet.addRow(studentsHeaders);
    const sh = studentsSheet.getRow(1);
    sh.font = { bold: true };
    sh.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E7D32' } };
    sh.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    studentsSheet.columns = [{ width: 18 }, { width: 22 }, { width: 10 }, { width: 12 }, { width: 14 }, { width: 28 }, { width: 16 }, { width: 18 }, { width: 12 }, { width: 12 }];
    for (const name of ['Staff', 'Supervisors']) {
      const sheet = workbook.addWorksheet(name, { views: [{ rightToLeft: false }] });
      sheet.addRow(staffHeaders);
      const headerRow = sheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E7D32' } };
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      sheet.columns = [{ width: 18 }, { width: 22 }, { width: 10 }, { width: 12 }, { width: 14 }, { width: 28 }];
    }
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(blob, 'onboard_template' + new Date().getTime() + EXCEL_EXTENSION);
    toast.success('Template downloaded');
  };

  const handleUploadExcel = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    setUploadExcelLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await doPostFormData(EndPoints.ONBOARD_WITHOUT_VIDEO_EXCEL, formData);
      setUploadExcelLoading(false);
      if (res?.status_code === 0) {
        toast.success(res?.message || `Created ${res?.created_count ?? 0} member(s)`);
        const refetchParams = {
          college_id: formDetails?.college_id,
          hostel_id: hostelId,
          page: pageNumber,
          page_size: 10,
          ...(hostellerSortColumn && { sort_by: hostellerSortColumn, sort_order: hostellerSortDirection }),
        };
        dispatch(Actions.hostellerList(refetchParams, () => {}));
      } else {
        toast.error(res?.message || 'Upload failed');
        if (res?.errors?.length) {
          res.errors.slice(0, 5).forEach((err) => {
            const loc = err.sheet ? `Sheet "${err.sheet}", Row ${err.row}` : `Row ${err.row}`;
            toast.error(`${loc}: ${err.error}`);
          });
        }
      }
    } catch {
      setUploadExcelLoading(false);
      toast.error('Upload failed');
    }
    e.target.value = '';
  };

  return (
    <>
      {
        isloading && <AppLoader />
      }
      {toggleConfirmPending && (
        <div className="modal-overlay d-flex align-items-center justify-content-center" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.4)',
          zIndex: 1050,
        }} onClick={() => setToggleConfirmPending(null)}>
          <div className="card shadow" style={{ width: '360px', maxWidth: '90vw' }} onClick={(e) => e.stopPropagation()}>
            <div className="card-body p-4">
              <h6 className="mb-3">Confirm status change</h6>
              <p className="text-muted mb-0">
                Are you sure you want to mark <strong>{toggleConfirmPending.name || 'this person'}</strong> as {toggleConfirmPending.active ? 'inactive' : 'active'}?
              </p>
              <div className="d-flex gap-2 mt-4 justify-content-end">
                <button type="button" className="btn btn-secondary btn-sm" onClick={() => setToggleConfirmPending(null)}>Cancel</button>
                <button type="button" className="btn btn-primary btn-sm" onClick={confirmToggleStatus}>Confirm</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12">
        <div className="card">

          <h5 className="card-header">
            <p>Onboarded List</p>
            <nav className="nav nav-pills flex-column flex-sm-row">
              {(user?.user_type === "0") && <button className={`flex-sm-fill text-sm-center nav-link ${tab === 1 ? "common_btn" : "nav-div"}`} onClick={() => handleTab(1)}>College</button>}
              <button className={`flex-sm-fill  text-sm-center nav-link ${((user?.user_type === "5") || (user?.user_type === "6")) ? "cursor_pointer_disable" : ""} ${(tab === 2 || user?.user_type === "5") || (user?.user_type === "6") ? "common_btn" : "nav-div"}`} onClick={() => handleTab(2)}>Hostler</button>
            </nav>
          </h5>
          <div className="card-body">
            <div className="">
              <div className="row mb-3">
                <div className="col-2 mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">Search</label>
                  <div className="search">
                    <i className="fa fa-search fa-1x"></i>
                    <input type="text" className="form-control" placeholder="Enter the Name/Employee ID" onChange={(e) => handleOnchangeSearch(e)} value={searchvalue} />
                    {
                      showList &&
                      <div className='searchAutoComplete'>
                        <div className="container searchAutoContainer">
                          {
                            searchData && Array.isArray(searchData) && searchData?.map((item, index) =>
                              <div className="row" key={index}>
                                <div className="col-3 searchcolumn">
                                  <img src={IMAGE_URL + item.img_url} alt="serach" style={{ width: "40px", height: "40px" }} />
                                </div>
                                <div className="col-9 searchcolumn2" onClick={() => Onsearch(item?.id)}>
                                  {item?.name},{item?.member_id}
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div className="col-2 mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">College</label>
                  <select value={formDetails?.college_id} onChange={(e) => handleCollegeSelect(e?.target?.value)}
                    className="form-select">
                    <option value='' hidden>Select College </option>
                    {Array.isArray(collegeList) && collegeList?.map((o) => {
                      return <option value={o?.id}>{o?.name}</option>

                    })
                    }
                  </select>
                </div>
                {(tab === 1 && (user?.user_type === "0" )) ? <div className="col-2 mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">Course</label>
                  <select value={formDetails?.course_id} disabled={formDetails?.college_id ? false : true} onChange={(e) => handleCourseSelect(e?.target?.value)}
                    className="form-select">
                    <option value='' hidden>Select Course</option>
                    {Array.isArray(courseList) && courseList?.map((o) => {
                      return <option value={o?.id}>{o?.name}</option>

                    })
                    }
                  </select>
                </div>
                  :
                  <div className="col-2 mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Hostel</label>
                    <select value={hostelId} disabled={formDetails?.college_id ? false : true} onChange={(e) => setHostelId(e?.target?.value)}
                      className="form-select">
                      <option value='' hidden>Select Hostel</option>
                      {Array.isArray(hostelList) && hostelList?.map((o) => {
                        return <option value={o?.id}>{o?.name}</option>

                      })
                      }
                    </select>
                  </div>
                }
                {(user?.user_type === "5" || user?.user_type === "0" || user?.user_type === "6") && (
                  <div className="col-2 mb-3 d-flex align-items-end">
                    <button className="btn btn-primary w-100"
                      onClick={() => {
                        handleAddNewPerson();
                      }}>
                      Add New Person
                    </button>
                  </div>
                )}
                {((user?.user_type === "5" || user?.user_type === "0" || user?.user_type === "6") && tab === 2) && (
                  <>
                    <div className="col-2 mb-3 d-flex align-items-end" ref={downloadDropdownRef}>
                      <div className="dropdown w-100" style={{ position: 'relative' }}>
                        <button
                          type="button"
                          className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                          disabled={isloading}
                          onClick={() => {
                            if (!hostelId) {
                              toast.warning('Please select college and hostel');
                              return;
                            }
                            setShowDownloadDropdown((v) => !v);
                          }}>
                          Download <i className="fas fa-chevron-down ms-2 small" />
                        </button>
                        {showDownloadDropdown && (
                          <ul className="dropdown-menu show" style={{ position: 'absolute', top: '100%', left: 0, zIndex: 1050, minWidth: '100%' }}>
                            <li>
                              <button type="button" className="dropdown-item" onClick={() => handleDownload()}>
                                With image
                              </button>
                            </li>
                            <li>
                              <button type="button" className="dropdown-item" onClick={() => handleDownloadWithoutImage()}>
                                Without image
                              </button>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                    <div className="col-2 mb-3 d-flex align-items-end">
                      <button type="button" className="btn btn-outline-success w-100"
                        onClick={handleDownloadTemplate}>
                        Download Template
                      </button>
                    </div>
                    <div className="col-2 mb-3 d-flex align-items-end">
                      <input
                        ref={excelUploadRef}
                        type="file"
                        accept=".xlsx,.xls"
                        className="d-none"
                        onChange={handleUploadExcel}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-primary w-100"
                        disabled={uploadExcelLoading}
                        onClick={() => excelUploadRef.current?.click()}>
                        {uploadExcelLoading ? 'Uploading...' : 'Upload Excel'}
                      </button>
                    </div>
                  </>
                )}
              </div>
              {((user?.user_type === "5" || user?.user_type === "0" || user?.user_type === "6") && tab === 2) && (
                <div className="card mb-3 border-info">
                  <div className="card-body py-3">
                    <h6 className="text-info mb-2"><i className="fas fa-info-circle me-1" /> Excel fill guide &amp; Hostel ID reference</h6>
                    <div className="row">
                      <div className="col-md-6">
                        <p className="small mb-1 fw-semibold">Instructions to fill the template:</p>
                        <ul className="small text-muted mb-0 ps-3">
                          <li><strong>member_id</strong>: Unique ID (Registered ID or Employee ID). No spaces.</li>
                          <li><strong>name</strong>: Full name (required).</li>
                          <li><strong>gender</strong>: Only <strong>M</strong> or <strong>F</strong> (required).</li>
                          <li><strong>hostel_id</strong>: Use the numeric ID from the table on the right (required).</li>
                          <li><strong>is_restricted</strong>:  <strong>1</strong>/<strong>0</strong> </li>
                          <li><strong>email</strong>: Valid email (required).</li>
                          <li><strong>Students sheet only</strong>: <strong>course</strong>, <strong>department</strong> (text), <strong>year_from</strong>, <strong>year_to</strong> (numbers, optional).</li>
                          <li><strong>Supervisors sheet</strong>: is_restricted and qr_access are set automatically; you can leave is_restricted as 0.</li>
                          <li>Video can be added later via &quot;Add Video&quot; in the list.</li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <p className="small mb-1 fw-semibold">Hostel ID reference (use these in hostel_id column):</p>
                        <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          <table className="table table-sm table-bordered mb-0 small">
                            <thead className="table-light sticky-top">
                              <tr>
                                <th>ID</th>
                                <th>Hostel name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(hostelList) && hostelList.length > 0 ? hostelList.map((h) => (
                                <tr key={h?.id}>
                                  <td><strong>{h?.id}</strong></td>
                                  <td>{h?.name ?? '-'}</td>
                                </tr>
                              )) : (
                                <tr><td colSpan={2} className="text-muted">Select college above to load hostels.</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}



              <div className="row mb-3">
                {(tab === 1 && (user?.user_type === "0" || user?.user_type === "6")) && <div className="col-sm-4 mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">Department</label>
                  <select disabled={formDetails?.course_id ? false : true} value={formDetails?.department_id} onChange={(e) => handleDepartmentSelect(e?.target?.value)}
                    className="form-select">
                    <option value='' hidden>Select Department</option>
                    {Array.isArray(departmentList) && departmentList?.map((o) => {
                      return <option value={o?.id}>{o?.name}</option>
                    })
                    }
                  </select>
                </div>}
                {(tab === 1 && (user?.user_type === "0" || user?.user_type === "6")) && <div className="col-sm-4 mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">Year</label>
                  <select value={formDetails?.year_id} disabled={formDetails?.department_id ? false : true} onChange={(e) => handleYearSelect(e?.target?.value)}
                    className="form-select">
                    <option value='' hidden>Select Year</option>
                    {Array.isArray(yearList) && yearList?.map((o) => {
                      return <option value={o?.id}>{o?.name}</option>
                    })}
                  </select>
                </div>}
                {(tab === 1 && (user?.user_type === "0" || user?.user_type === "6")) && <div className="col-sm-4 mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">Section</label>
                  <select value={formDetails?.section_id} disabled={formDetails?.year_id ? false : true} onChange={(e) => handleSectionSelect(e?.target?.value)}
                    className="form-select">
                    <option value='' hidden>Select Section</option>
                    {Array.isArray(sectionList) && sectionList?.map((o) => {
                      // return o?.sections?.map((o) => {
                      return <option value={o?.id}>{o?.name}</option>
                      // })

                    })}
                  </select>
                </div>}
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            {isEditModalOpen && (
              <div className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}>

                <div className="card p-4 shadow-sm" style={{
                  minWidth: "300px",
                  maxWidth: "500px",
                  position: "relative",
                  maxHeight: "90vh",
                  overflowY: "auto"
                }}>
                  <button
                    onClick={handleCloseModal}
                    className="btn btn-light position-absolute top-0 end-0 mt-2 me-2"
                    style={{ fontSize: "20px", lineHeight: "1" }}
                  >
                    ×
                  </button>

                  <h5 className="mb-3">{editItem?.mask_flag ? 'Add Video' : 'Edit Hosteller'}: {editItem?.name}</h5>

                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editItem?.name || ""}
                      onChange={(e) => setEditItem({ ...editItem, name: e.target.value })}
                      placeholder="Enter name"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Room Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editItem?.room_number || ""}
                      onChange={(e) => setEditItem({ ...editItem, room_number: e.target.value })}
                      placeholder="Enter room number"
                    />
                  </div>

                  {editItem?.subject_type === '2' && (
                    <div className="mb-3">
                      <label className="form-label">Access Type</label>
                      <div className="btn-group d-flex" role="group">
                        <button
                          type="button"
                          className={`btn ${!editItem?.has_24_7_access ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setEditItem({ ...editItem, has_24_7_access: false })}
                        >
                          <i className="fas fa-clock me-2 text-warning"></i>
                          Normal Access
                        </button>
                        <button
                          type="button"
                          className={`btn ${editItem?.has_24_7_access ? "btn-primary" : "btn-outline-primary"}`}
                          onClick={() => setEditItem({ ...editItem, has_24_7_access: true })}
                        >
                          <i className="fas fa-shield-alt me-2 text-success"></i>
                          24/7 Access
                        </button>
                      </div>
                    </div>
                  )}

                  {/* <div className="mb-3">
                    <label className="form-label">Member ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editItem?.member_id || ""}
                      onChange={(e) => setEditItem({ ...editItem, member_id: e.target.value })}
                      placeholder="Enter Member ID"
                      disabled={editItem?.onboarding_status === 1} // Disable if status is rejected
                    />
                  </div> */}

                  {/* Show current onboarding status */}
                  <div className="mb-3">
                    <label className="form-label">Onboarding Status</label>
                    <div className={`badge ${editItem?.onboarding_status === 0
                      ? 'bg-warning'
                      : editItem?.onboarding_status === 1
                        ? 'bg-danger'
                        : 'bg-success'} p-2 w-100 text-center`}>
                      {editItem?.onboarding_status === 0
                        ? "Not Approved"
                        : editItem?.onboarding_status === 1
                          ? "Rejected"
                          : "Accepted"}
                    </div>
                    {editItem?.onboarding_status === 1 && editItem?.onboarding_remarks && (
                      <div className="mt-2">
                        <small className="text-muted">Remarks:</small>
                        <p className="text-danger small mb-0">{editItem?.onboarding_remarks}</p>
                      </div>
                    )}
                  </div>

                  {/* Video Upload Section - Show when status is 1 (Rejected) or mask_flag (no video yet) */}
                  {(editItem?.onboarding_status === 1 || editItem?.mask_flag) && (
                    <div className="mb-4 border rounded p-3">
                      <label className="form-label fw-bold">
                        {editItem?.mask_flag ? 'Add Video' : 'Re-upload Video'} <span className="text-danger">*</span>
                      </label>
                      <p className="text-muted small mb-3">
                        {editItem?.mask_flag
                          ? 'This person was onboarded without video. Upload a video for face recognition.'
                          : "This person's onboarding was rejected. Please upload a new video for approval."}
                      </p>

                      {!editVideoFile ? (
                        <div className="video-upload-placeholder">
                          <div className="d-flex flex-column align-items-center">
                            <label className="btn btn-outline-primary w-100 mb-2">
                              <i className="fas fa-upload me-2"></i>
                              Choose New Video File
                              <input
                                type="file"
                                accept="video/*"
                                onChange={handleEditVideoUpload}
                                style={{ display: 'none' }}
                              />
                            </label>
                            <small className="text-muted">Max size: 50MB</small>
                          </div>
                        </div>
                      ) : (
                        <div className="video-preview">
                          <div className="d-flex justify-content-between align-items-start mb-3">
                            <h6 className="mb-0">New Video Preview</h6>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={removeEditVideo}
                            >
                              <i className="fas fa-times me-1"></i> Remove
                            </button>
                          </div>
                          <div className="video-container mb-3">
                            <video
                              controls
                              className="rounded"
                              style={{ maxWidth: '100%', maxHeight: '150px' }}
                            >
                              <source src={editVideoPreview} type={editVideoFile.type} />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                          <div className="video-info small">
                            <p className="mb-1">
                              <strong>File:</strong> {editVideoFile.name}
                            </p>
                            <p className="mb-1">
                              <strong>Size:</strong> {(editVideoFile.size / (1024 * 1024)).toFixed(2)} MB
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* <div className="mb-3">
                    <label className="form-label">Status</label>
                    <div className="d-flex align-items-center">
                      <i
                        className={editItem?.is_active ?
                          "fa-solid fa-toggle-on fa-2xl cursor-pointer text-primary" :
                          "fa-solid fa-toggle-off fa-2xl cursor-pointer text-secondary"}
                        onClick={() => setEditItem({ ...editItem, is_active: !editItem?.is_active })}
                        style={{ cursor: "pointer" }}
                        title={`Click to mark as ${editItem?.is_active ? "inactive" : "active"}`}
                      />
                      <label className={`form-check-label ms-2 fw-medium ${editItem?.is_active ? "text-primary" : "text-secondary"}`}>
                        {editItem?.is_active ? "Active" : "Inactive"}
                      </label>
                    </div>
                  </div> */}

                  {/* Action buttons section */}
                  <div className="d-flex justify-content-between mt-4 pt-3 border-top">
                    {/* Delete button on the left */}
                    <button
                      className="btn btn-outline-danger d-flex align-items-center"
                      onClick={() => {
                        if (window.confirm(`Are you sure you want to delete "${editItem?.name}"? This action cannot be undone.`)) {
                          hosteller_delete(editItem?.member_id);
                          handleCloseModal();
                        }
                      }}
                    >
                      <i className="fa-solid fa-trash-can me-2"></i>
                      Delete
                    </button>

                    <div className="d-flex">
                      <button
                        className="btn btn-outline-secondary me-2"
                        onClick={handleCloseModal}
                      >
                        Cancel
                      </button>

                      {/* Conditional Save/Re-upload/Add Video Button */}
                      {(editItem?.onboarding_status === 1 || editItem?.mask_flag) ? (
                        <button
                          className="btn btn-success d-flex align-items-center"
                          onClick={handleReuploadVideo}
                          disabled={!editVideoFile || isloading}
                        >
                          {isloading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              Uploading...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-cloud-upload-alt me-2"></i>
                              {editItem?.mask_flag ? 'Add Video' : 'Re-upload Video'}
                            </>
                          )}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary d-flex align-items-center"
                          onClick={() => hosteller_update(editItem)}
                          disabled={isloading}
                        >
                          {isloading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                              Saving...
                            </>
                          ) : (
                            <>
                              <i className="fa-solid fa-floppy-disk me-2"></i>
                              Save Changes
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}




            <div className="table-responsive">
              {

                (tab === 1 && (user?.user_type === "0" || user?.user_type === "6")) &&
                (
                  ((onboardedList?.results && onboardedList?.results?.length > 0) || (onboardedList?.response && onboardedList?.response?.length > 0))
                    ?
                    <table className="table onboardTable">
                      <thead className="bg-light">

                        <tr className="border-0">
                          <th className="border-0 text-center">S.No</th>
                          <th className="border-0 text-center">Image</th>
                          <th className="border-0 text-center">Name</th>
                          <th className="border-0 text-center">Employee ID</th>
                          <th className="border-0 text-center">Mask Status</th>
                          <th className="border-0 text-center">Re-generate password</th>
                          <th className="border-0 text-center">Status</th>
                          <th className="border-0 text-center">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          ((tab === 1 && (user?.user_type === "0" || user?.user_type === "6")) &&
                            ((onboardedList?.results || onboardedList?.response) && (onboardedList?.results?.length > 0 ? onboardedList?.results : onboardedList?.response))).map((item, index) =>
                              <tr>
                                <td className=" text-center">{((pageNumber - 1) * 10) + (index + 1)}</td>
                                <td className=" text-center">
                                  <div className="m-r-10"><img src={item?.img_url ? `${url + item?.img_url}` : Placeholder} alt="user" className="rounded" width="45" /></div>
                                </td>
                                <td className=" text-center">{item?.name} </td>
                                <td className=" text-center">{item?.member_id} </td>
                                <td className=" text-center">{item?.mask_flag ? <>
                                  <i className='fas fa-head-side-mask'></i> <i className='fas fa-head-side-cough-slash'></i>
                                </> : <>
                                  <i className='fas fa-head-side-cough-slash'></i>
                                </>
                                } </td>
                                <td className="text-center" ><button className="btn btn-primary" onClick={() => openGeneratPasswordeAlert(item?.member_id)}><i class="fas fa-lock cursor-pointer" ></i> Change password</button></td>
                                <td className=" text-center">
                                  <i className={item.is_active ? "fa-solid fa-toggle-on fa-2xl cursor-pointer" : "fa-solid fa-toggle-off fa-2xl cursor-pointer"} onClick={() => setToggleConfirmPending({ id: item?.id, active: item?.is_active, name: item?.name })} />
                                </td>
                                <td className=" text-center"><i className="fa fa-lg fa-trash cursor-pointer" aria-hidden="true" onClick={() => handleClick(item)}></i></td>
                              </tr>
                            )
                        }
                        {
                          isSearch ? <></> :
                            <tr>
                              <td colspan="9">
                                <PaginationComponent onChangeHandle={onChangeHandle} pageCount={count} pageNumber={pageNumber} setpage={setPageNumber} />
                              </td>
                            </tr>
                        }
                      </tbody>
                    </table>
                    :
                    <div className="d-flex justify-content-center mt-5 mb-5">
                      <div className="NodataFound">
                        <h3>No Data Found</h3>
                      </div>
                      <div className="NodataImage">
                        <img src={nodatafound} alt="No Data Found" className="NoData" />
                      </div>
                    </div>
                )
              }
              {
                (tab === 2 && (
                  hostellerList?.length > 0 ?
                    <table className="table onboardTable">
                      <thead className="bg-light">
                        <tr className="border-0">
                          <th className="border-0 text-center">S.No</th>
                          <th className="border-0 text-center">Image</th>
                          <HostellerSortableHeader column="name" label="Name" />
                          <HostellerSortableHeader column="member_id" label="Person ID" />
                          <HostellerSortableHeader column="room_number" label="Room Number" />
                          <HostellerSortableHeader column="role" label="Role" />
                          <HostellerSortableHeader column="course" label="Course" />
                          <HostellerSortableHeader column="department" label="Department" />
                          <HostellerSortableHeader column="joining_year" label="Joining Year" />
                          <HostellerSortableHeader column="onboarding_status" label="Onboarding status" />
                          <th className="border-0 text-center">Remarks</th>
                          <HostellerSortableHeader column="is_active" label="Status" />
                          <th className="border-0 text-center">Video</th>
                          <th className="border-0 text-center">Edit</th>
                          {tab === "1" && (
                            <th className="border-0 text-center">Delete</th>)}

                        </tr>
                      </thead>
                      <tbody>
                        {
                          tab === 2 &&
                          hostellerList?.length > 0 && hostellerList?.map((item, index) =>
                            <tr>
                              <td className=" text-center">{((pageNumber - 1) * 10) + (index + 1)}</td>
                              <td className=" text-center">
                                <div className="m-r-10"><img src={item?.img_url ? `${url + item?.img_url}` : Placeholder} alt="user" className="rounded" width="45" /></div>
                              </td>
                              <td className=" text-center">{item?.name} </td>
                              <td className=" text-center">{item?.member_id} </td>
                              <td className=" text-center">{item?.room_number || '-'} </td>
                              <td className=" text-center">
                                {(() => {
                                  const role = item?.role ?? getRoleLabel(item?.subject_type);
                                  const badgeClass = role === 'Student' ? 'bg-primary' : role === 'Supervisor' ? 'bg-info' : role === 'Admin' ? 'bg-dark' : 'bg-secondary';
                                  return <span className={`badge ${badgeClass}`}>{role}</span>;
                                })()}
                              </td>
                              <td className=" text-center">{item?.course} </td>
                              <td className=" text-center">{item?.department} </td>
                              <td className=" text-center">{item?.joining_year} </td>

                              <td className="text-center">
                                {item?.onboarding_status === 0
                                  ? "Not Approved"
                                  : item?.onboarding_status === 1
                                    ? "Rejected"
                                    : "Accepted"}
                              </td>
                              <td className=" text-center">{item?.onboarding_remarks === null
                                ? "The video is in correct format"

                                : item?.onboarding_remarks} </td>
                                <td className="text-center">
                                <i
                                  className={item.is_active ? 
                                    "fa-solid fa-toggle-on fa-2xl cursor-pointer text-primary" : 
                                    "fa-solid fa-toggle-off fa-2xl cursor-pointer text-secondary"}
                                  onClick={() => setToggleConfirmPending({ id: item?.id, active: item?.is_active, name: item?.name })}
                                  style={{ cursor: "pointer", fontSize: "1.5rem" }}
                                  title={`Click to mark as ${item?.is_active ? "inactive" : "active"}`}
                                />
                              </td>


                              <td className="text-center">
                                {item?.mask_flag ? (
                                  <button
                                    className="btn btn-outline-success btn-sm"
                                    onClick={() => handleEdit(item)}
                                    title="Add Video"
                                    style={{ minWidth: '90px' }}
                                  >
                                    <i className="fas fa-plus me-1"></i>
                                    Add Video
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => handleViewVideo(item?.member_id, item)}
                                    title="View Video"
                                    style={{ minWidth: '80px' }}
                                  >
                                    <i className="fas fa-video me-1"></i>
                                    View
                                  </button>
                                )}
                              </td>

                              {/* <td className="text-center" ><button className="btn btn-primary" onClick={() => openGeneratPasswordeAlert(item?.member_id)}><i class="fas fa-lock cursor-pointer" ></i> Change password</button></td> */}
                              {tab === "1" && (
                                <td className=" text-center">
                                  <i className={item.is_active ? "fa-solid fa-toggle-on fa-2xl cursor-pointer" : "fa-solid fa-toggle-off fa-2xl cursor-pointer"} onClick={() => setToggleConfirmPending({ id: item?.id, active: item?.is_active, name: item?.name })} />
                                </td>)}
                              {(user?.user_type === "5" || user?.user_type === "0" || user?.user_type === "6") && (
                                <td className="text-center">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => handleEdit(item)}
                                  >
                                    Edit
                                  </button>
                                </td>
                              )}
                              {tab === "1" && (
                                <td className=" text-center"><i className="fa  fa-lg fa-trash cursor-pointer" aria-hidden="true" onClick={() => handleClick(item)}></i></td>)}
                            </tr>
                          )
                        }
                        {
                          isSearch ? <></> :
                            <tr>
                              <td colspan="9">
                                <PaginationComponent onChangeHandle={onChangeHandle} pageCount={count} pageNumber={pageNumber} setpage={setPageNumber} />
                              </td>
                            </tr>
                        }
                      </tbody>
                    </table>
                    :
                    <div className="d-flex justify-content-center mt-5 mb-5">
                      <div className="NodataFound">
                        <h3>No Data Found</h3>
                      </div>
                      <div className="NodataImage">
                        <img src={nodatafound} alt="No Data Found" className="NoData" />
                      </div>
                    </div>
                ))
              }
            </div>
          </div>
        </div>
        {
          alertGenPasswordModal && <AlertGeneratePsswordModal onClose={() => setAlertGetPasswordModal(false)} user_name={user_name} />
        }
      </div>


      {isOpenDeclineModal && <DeclinePopup
        title={`Are you sure you want to delete ${itemObj?.name}?`}
        onClose={() => onCloseModel()}
        onSuccess={() => deleteMember()}
      />}
      {isAddUserModalOpen && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1050
        }}>
          <div className="modal-content card" style={{ width: '600px', maxWidth: '95vw', maxHeight: '90vh', overflow: 'auto' }}>
            <div className="card-header d-flex justify-content-between align-items-center sticky-top bg-white">
              <h5 className="mb-0">Add New Person</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setAddUserModalOpen(false);
                  setPersonType('');
                  restoreMainPageLists();
                  // Clean up video URL
                  if (newPersonForm.videoPreview) {
                    URL.revokeObjectURL(newPersonForm.videoPreview);
                  }
                  setNewPersonForm({
                    name: '',
                    member_id: '',
                    college_id: '',
                    department_id: '',
                    course_id: '',
                    course: '',
                    department: '',
                    section_id: '',
                    hostel_id: '',
                    is_active: true,
                    person_category: '',
                    videoFile: null,
                    videoPreview: null
                  });
                }}
              ></button>
            </div>

            <div className="card-body">
              {/* Step 1: Select Person Type */}
              {!personType ? (
                <div className="text-center">
                  <h6 className="mb-4">Select Person Type</h6>
                  <p className="text-muted mb-4">Please select whether you're adding a student or other person</p>
                  <div className="row g-3">
                    <div className="col-6">
                      <button
                        className="btn btn-outline-primary w-100 py-4 h-100"
                        onClick={() => setPersonType('student')}
                        style={{ minHeight: '120px' }}
                      >
                        <i className="fas fa-graduation-cap fa-2x mb-2 d-block"></i>
                        <div className="fw-bold">Student</div>
                        <small className="text-muted">College students</small>
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="btn btn-outline-primary w-100 py-4 h-100"
                        onClick={() => setPersonType('other')}
                        style={{ minHeight: '120px' }}
                      >
                        <i className="fas fa-users fa-2x mb-2 d-block"></i>
                        <div className="fw-bold">Other</div>
                        <small className="text-muted">Staff, Faculty or supervisor</small>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                /* Step 2: Form based on selected type */
                <div>
                  <div className="mb-3">
                    <button
                      className="btn btn-sm btn-outline-secondary mb-3"
                      onClick={() => {
                        setPersonType('');
                        if (newPersonForm.videoPreview) {
                          URL.revokeObjectURL(newPersonForm.videoPreview);
                        }
                        setNewPersonForm({
                          ...newPersonForm,
                          videoFile: null,
                          videoPreview: null
                        });
                      }}
                    >
                      <i className="fas fa-arrow-left me-2"></i> Change Person Type
                    </button>
                  </div>

                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleAddPersonSubmit();
                  }}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Name <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          value={newPersonForm.name}
                          onChange={(e) => setNewPersonForm({ ...newPersonForm, name: e.target.value })}
                          required
                          placeholder="Enter full name"
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label">Member ID <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          value={newPersonForm.member_id}
                          onChange={(e) => setNewPersonForm({ ...newPersonForm, member_id: e.target.value })}
                          required
                          placeholder="Enter unique ID"
                        />
                      </div>
                    </div>


                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Gender <span className="text-danger">*</span></label>
                        <div className="btn-group w-100" role="group">
                          <button
                            type="button"
                            className={`btn ${newPersonForm.gender === 'M' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setNewPersonForm({ ...newPersonForm, gender: 'M' })}
                          >
                            <i className="fas fa-mars me-2"></i> Male
                          </button>
                          <button
                            type="button"
                            className={`btn ${newPersonForm.gender === 'F' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setNewPersonForm({ ...newPersonForm, gender: 'F' })}
                          >
                            <i className="fas fa-venus me-2"></i> Female
                          </button>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          value={newPersonForm.email}
                          onChange={(e) => setNewPersonForm({ ...newPersonForm, email: e.target.value })}
                          required
                          placeholder="Enter email address"
                        />
                      </div>
                    </div>



                    {/* Video Upload Section */}
                    <div className="mb-4">
                      <label className="form-label">Video Upload <span className="text-danger">*</span></label>
                      <div className="border rounded p-3 text-center">
                        {!newPersonForm.videoFile ? (
                          <div className="video-upload-placeholder">
                            <i className="fas fa-video fa-3x text-muted mb-3"></i>
                            <p className="text-muted mb-2">Upload a short video of the person</p>
                            <p className="text-muted small mb-3">(Required for face recognition)</p>
                            <div className="d-flex flex-column align-items-center">
                              <label className="btn btn-primary mb-2">
                                <i className="fas fa-upload me-2"></i>
                                Choose Video File
                                <input
                                  type="file"
                                  accept="video/*"
                                  onChange={handleVideoUpload}
                                  style={{ display: 'none' }}
                                  required
                                />
                              </label>
                              <small className="text-muted">Max size: 50MB</small>
                              <small className="text-muted">Accepted formats: MP4, AVI, MOV</small>
                            </div>
                          </div>
                        ) : (
                          <div className="video-preview">
                            <div className="d-flex justify-content-between align-items-start mb-3">
                              <h6 className="mb-0">Video Preview</h6>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={removeVideo}
                              >
                                <i className="fas fa-times me-1"></i> Remove
                              </button>
                            </div>
                            <div className="video-container mb-3">
                              <video
                                controls
                                className="rounded"
                                style={{ maxWidth: '100%', maxHeight: '200px' }}
                              >
                                <source src={newPersonForm.videoPreview} type={newPersonForm.videoFile.type} />
                                Your browser does not support the video tag.
                              </video>
                            </div>
                            <div className="video-info">
                              <p className="mb-1">
                                <strong>File:</strong> {newPersonForm.videoFile.name}
                              </p>
                              <p className="mb-1">
                                <strong>Size:</strong> {(newPersonForm.videoFile.size / (1024 * 1024)).toFixed(2)} MB
                              </p>
                              <p className="mb-0">
                                <strong>Type:</strong> {newPersonForm.videoFile.type}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Student-specific fields */}
                    {personType === 'student' && (
                      <>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">College <span className="text-danger">*</span></label>
                            <select
                              className="form-select"
                              value={newPersonForm.college_id}
                              onChange={(e) => {
                                const v = e.target.value;
                                setNewPersonForm({
                                  ...newPersonForm,
                                  college_id: v,
                                  course_id: '',
                                  course: '',
                                  department_id: '',
                                  department: '',
                                  section_id: ''
                                });
                              }}
                              required
                            >
                              <option value="">Select College</option>
                              {Array.isArray(collegeList) && collegeList.map((c) => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Course <span className="text-danger">*</span></label>
                            <CourseTypehead
                              formDetails={{ college_id: newPersonForm.college_id }}
                              placeholder="Search and select course..."
                              value={newPersonForm.course_id ? { value: newPersonForm.course_id, label: newPersonForm.course || 'Selected' } : null}
                              onChange={(opt) => setNewPersonForm({
                                ...newPersonForm,
                                course_id: opt?.value || '',
                                course: opt?.label || '',
                                department_id: '',
                                department: ''
                              })}
                              isDisabled={!newPersonForm.college_id}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Department <span className="text-danger">*</span></label>
                            <DepartmentTypehead
                              formDetails={{ course_id: newPersonForm.course_id }}
                              placeholder="Search and select department..."
                              value={newPersonForm.department_id ? { value: newPersonForm.department_id, label: newPersonForm.department || 'Selected' } : null}
                              onChange={(opt) => setNewPersonForm({
                                ...newPersonForm,
                                department_id: opt?.value || '',
                                department: opt?.label || ''
                              })}
                              isDisabled={!newPersonForm.course_id}
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <label className="form-label">Year From <span className="text-danger">*</span></label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="fas fa-calendar-start"></i>
                                </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={newPersonForm.year_from}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    // Always allow typing
                                    setNewPersonForm({ ...newPersonForm, year_from: value });
                                  }}
                                  onBlur={(e) => {
                                    const num = parseInt(e.target.value);
                                    if (num < 2000 || num > 2100) {
                                      alert("Year must be between 2000 and 2100");
                                      setNewPersonForm({ ...newPersonForm, year_from: "" });
                                    }
                                  }}
                                  required
                                  min="2000"
                                  max="2100"
                                  placeholder="e.g., 2024"
                                />

                              </div>
                              <small className="text-muted">Enter start year (2000-2100)</small>
                            </div>

                            <div className="col-md-6">
                              <label className="form-label">Year To <span className="text-danger">*</span></label>
                              <div className="input-group">
                                <span className="input-group-text">
                                  <i className="fas fa-calendar-end"></i>
                                </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={newPersonForm.year_to}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    setNewPersonForm({ ...newPersonForm, year_to: value });

                                  }}
                                  required
                                  min={newPersonForm.year_from || 2000}
                                  max="2100"
                                  placeholder="e.g., 2028"
                                  disabled={!newPersonForm.year_from}
                                />
                              </div>
                              <small className="text-muted">
                                Enter end year (must be ≥ {newPersonForm.year_from || 'start year'})
                              </small>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-md-12">
                              <label className="form-label">Access Type <span className="text-danger">*</span></label>

                              <div className="btn-group d-flex" role="group">
                                <button
                                  type="button"
                                  className={`btn ${!newPersonForm.has_24_7_access ? "btn-primary" : "btn-outline-primary"}`}
                                  onClick={() => setNewPersonForm({ ...newPersonForm, has_24_7_access: false })}
                                >
                                  <i className="fas fa-clock me-2 text-warning"></i>
                                  Normal Access
                                </button>

                                <button
                                  type="button"
                                  className={`btn ${newPersonForm.has_24_7_access ? "btn-primary" : "btn-outline-primary"}`}
                                  onClick={() => setNewPersonForm({ ...newPersonForm, has_24_7_access: true })}
                                >
                                  <i className="fas fa-shield-alt me-2 text-success"></i>
                                  24/7 Access
                                </button>
                              </div>
                            </div>
                          </div>


                        </div>

                        <div className="mb-3">
                          <label className="form-label">Hostel <span className="text-danger">*</span></label>
                          <select
                            className="form-select"
                            value={newPersonForm.hostel_id}
                            required
                            onChange={(e) => setNewPersonForm({ ...newPersonForm, hostel_id: e.target.value })}
                          >
                            <option value="">Select Hostel</option>
                            {Array.isArray(hostelList) && hostelList.map((hostel) => (
                              <option key={hostel.id} value={hostel.id}>{hostel.name}</option>
                            ))}
                          </select>
                        </div>
                      </>
                    )}

                    {/* Other-specific fields */}
                    {personType === 'other' && (
                      <>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label">Person Category <span className="text-danger">*</span></label>
                            <select
                              className="form-select"
                              value={newPersonForm.person_category}
                              onChange={(e) => setNewPersonForm({ ...newPersonForm, person_category: e.target.value })}
                              required
                            >
                              <option value="">Select Category</option>
                              <option value="teaching_staff">Teaching Staff</option>
                              <option value="working_staff">Working Staff</option>
                              {user?.user_type === "6" && <option value="supervisor">Supervisor</option>}
                            </select>
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="form-label">Hostel <span className="text-danger">*</span></label>
                            <select
                              className="form-select"
                              value={newPersonForm.hostel_id}
                              onChange={(e) => setNewPersonForm({ ...newPersonForm, hostel_id: e.target.value })}
                              required
                            >
                              <option value="">Select Hostel</option>
                              {Array.isArray(hostelList) && hostelList.map((hostel) => (
                                <option key={hostel.id} value={hostel.id}>{hostel.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="mb-3">
                      <label className="form-label">Status</label>
                      <div className="d-flex align-items-center">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckChecked"
                            checked={newPersonForm.is_active}
                            onChange={(e) => setNewPersonForm({ ...newPersonForm, is_active: e.target.checked })}
                            style={{ width: '3em', height: '1.5em' }}
                          />
                          <label className="form-check-label ms-2 fw-medium" htmlFor="flexSwitchCheckChecked">
                            {newPersonForm.is_active ? "Active" : "Inactive"}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="alert alert-info">
                      <i className="fas fa-info-circle me-2"></i>
                      <strong>Note:</strong> A clear face video is required for face recognition system.
                      Ensure the person's face is clearly visible in the video.
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          setAddUserModalOpen(false);
                          setPersonType('');
                          restoreMainPageLists();
                          if (newPersonForm.videoPreview) {
                            URL.revokeObjectURL(newPersonForm.videoPreview);
                          }
                          setNewPersonForm({
                            name: '',
                            member_id: '',
                            college_id: '',
                            department_id: '',
                            course_id: '',
                            course: '',
                            department: '',
                            section_id: '',
                            hostel_id: '',
                            is_active: true,
                            person_category: '',
                            videoFile: null,
                            videoPreview: null,
                            gender: '',
                            year_from: '',
                            year_to: '',
                            has_24_7_access: false
                          });
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isloading || !newPersonForm.videoFile}
                      >
                        {isloading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Adding...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-plus-circle me-2"></i>
                            Add Person
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Video View Modal */}

      {/* Video View Modal */}
      {videoModalOpen && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1060
        }}>
          <div className="modal-content card" style={{
            width: '800px', // Increased width for more content
            maxWidth: '95vw',
            maxHeight: '90vh',
            position: 'relative'
          }}>
            <div className="card-header d-flex justify-content-between align-items-center sticky-top bg-white">
              <h5 className="mb-0">Video Preview - {selectedMemberId}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setVideoModalOpen(false);
                  setSectionIdInput('');
                  setVideoUrl('');
                  setIsLoadingVideo(false);
                  setCurrentVideoItem(null);
                  setShowRejectModal(false);
                  setRejectRemarks('');
                }}
              ></button>
            </div>

            <div className="card-body p-4">
              {/* Person Information Section */}
              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="card bg-light">
                    <div className="card-body">
                      <h6 className="card-subtitle mb-2 text-muted">Person Information</h6>
                      <div className="row">
                        <div className="col-12 mb-2">
                          <small className="text-muted">Name:</small>
                          <div className="fw-bold">{currentVideoItem?.name}</div>
                        </div>
                        <div className="col-12 mb-2">
                          <small className="text-muted">Member ID:</small>
                          <div className="fw-bold">{currentVideoItem?.member_id}</div>
                        </div>
                        <div className="col-6 mb-2">
                          <small className="text-muted">Course:</small>
                          <div className="fw-bold">{currentVideoItem?.course_name || 'N/A'}</div>
                        </div>
                        <div className="col-6 mb-2">
                          <small className="text-muted">Department:</small>
                          <div className="fw-bold">{currentVideoItem?.department_name || 'N/A'}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card bg-light">
                    <div className="card-body">
                      <h6 className="card-subtitle mb-2 text-muted">Onboarding Status</h6>
                      <div className="d-flex flex-column">
                        <span className={`badge ${currentVideoItem?.onboarding_status === 0
                          ? 'bg-warning'
                          : currentVideoItem?.onboarding_status === 1
                            ? 'bg-danger'
                            : 'bg-success'
                          } p-2 mb-2`}>
                          Status: {
                            currentVideoItem?.onboarding_status === 0
                              ? "Pending Approval"
                              : currentVideoItem?.onboarding_status === 1
                                ? "Rejected"
                                : "Accepted"
                          }
                        </span>
                        {currentVideoItem?.onboarding_remarks && (
                          <div>
                            <small className="text-muted">Remarks: </small>
                            <div className="text-danger small">{currentVideoItem.onboarding_remarks}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Video View Modal - Fixed Alignment */}
              {videoModalOpen && (
                <div className="modal fade show d-block" style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0,0,0,0.8)',
                  zIndex: 1060,
                  overflowY: 'auto'
                }}>
                  <div className="modal-dialog modal-dialog-centered modal-xl" style={{
                    maxWidth: '900px',
                    margin: '20px auto',
                    display: 'flex',
                    minHeight: 'calc(100% - 40px)',
                    alignItems: 'center'
                  }}>
                    <div className="modal-content" style={{
                      maxHeight: '90vh',
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      <div className="modal-header bg-white sticky-top" style={{ zIndex: 1 }}>
                        <h5 className="modal-title mb-0">
                          <i className="fas fa-video me-2 text-primary"></i>
                          Video Preview - {currentVideoItem?.name || selectedMemberId}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => {
                            setVideoModalOpen(false);
                            setSectionIdInput('');
                            setVideoUrl('');
                            setIsLoadingVideo(false);
                            setCurrentVideoItem(null);
                            setShowRejectModal(false);
                            setRejectRemarks('');
                          }}
                          aria-label="Close"
                        ></button>
                      </div>

                      <div className="modal-body p-4" style={{
                        overflowY: 'auto',
                        flex: '1 1 auto'
                      }}>
                        {/* Person Information Section */}
                        <div className="row g-3 mb-4">
                          <div className="col-md-6">
                            <div className="card border-0 shadow-sm h-100">
                              <div className="card-header bg-light">
                                <h6 className="mb-0"><i className="fas fa-user me-2"></i>Person Information</h6>
                              </div>
                              <div className="card-body">
                                <div className="row g-2">
                                  <div className="col-12">
                                    <div className="d-flex align-items-center mb-2">
                                      <div className="me-3" style={{ minWidth: '100px' }}>
                                        <small className="text-muted">Name:</small>
                                      </div>
                                      <div className="fw-bold text-truncate">{currentVideoItem?.name || 'N/A'}</div>
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="d-flex align-items-center mb-2">
                                      <div className="me-3" style={{ minWidth: '100px' }}>
                                        <small className="text-muted">Member ID:</small>
                                      </div>
                                      <div className="fw-bold">{currentVideoItem?.member_id || selectedMemberId}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="card border-0 shadow-sm h-100">
                              <div className="card-header bg-light">
                                <h6 className="mb-0"><i className="fas fa-clipboard-check me-2"></i>Onboarding Status</h6>
                              </div>
                              <div className="card-body">
                                <div className="d-flex flex-column h-100 justify-content-center">
                                  <div className={`badge ${currentVideoItem?.onboarding_status === 0
                                    ? 'bg-warning'
                                    : currentVideoItem?.onboarding_status === 1
                                      ? 'bg-danger'
                                      : 'bg-success'
                                    } p-3 mb-3 text-center fs-6`}>
                                    <i className={`fas ${currentVideoItem?.onboarding_status === 0
                                      ? 'fa-clock'
                                      : currentVideoItem?.onboarding_status === 1
                                        ? 'fa-times-circle'
                                        : 'fa-check-circle'
                                      } me-2`}></i>
                                    {
                                      currentVideoItem?.onboarding_status === 0
                                        ? "Pending Approval"
                                        : currentVideoItem?.onboarding_status === 1
                                          ? "Rejected"
                                          : "Accepted"
                                    }
                                  </div>
                                  {currentVideoItem?.onboarding_remarks && currentVideoItem.onboarding_status === 1 && (
                                    <div className="mt-2">
                                      <small className="text-muted d-block mb-1">Rejection Remarks:</small>
                                      <div className="alert alert-danger py-2 px-3 mb-0 small">
                                        <i className="fas fa-exclamation-circle me-2"></i>
                                        {currentVideoItem.onboarding_remarks}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Video Player Section */}
                        <div className="mb-4">
                          <div className="card border-0 shadow-sm">
                            <div className="card-header bg-light">
                              <h6 className="mb-0"><i className="fas fa-play-circle me-2"></i>Video Preview</h6>
                            </div>
                            <div className="card-body p-0">
                              {isLoadingVideo ? (
                                <div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ minHeight: '300px' }}>
                                  <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                  <p className="text-muted">Loading video...</p>
                                </div>
                              ) : videoUrl ? (
                                <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                                  <video
                                    key={videoUrl}
                                    controls
                                    autoPlay
                                    crossOrigin="anonymous"
                                    style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      borderRadius: '8px',
                                      backgroundColor: '#000'
                                    }}
                                    onError={(e) => {
                                      console.error('Video loading error:', e);
                                      toast.error('Failed to load video. Please try again.');
                                    }}
                                  >
                                    <source src={videoUrl} type="video/mp4" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              ) : (
                                <div className="d-flex flex-column align-items-center justify-content-center py-5 border rounded" style={{ minHeight: '300px' }}>
                                  <i className="fas fa-video-slash fa-3x text-muted mb-3"></i>
                                  <h5 className="text-muted mb-2">Video Not Available</h5>
                                  <p className="text-muted text-center">No video found for this person.</p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {(user?.user_type === "0" || user?.user_type === "6") && currentVideoItem?.onboarding_status === 0 && currentVideoItem?.subject_type === "2" && (
                          <div className="mb-4">
                            <div className="card border-0 shadow-sm">
                              <div className="card-header bg-light">
                                <h6 className="mb-0"><i className="fas fa-id-card me-2"></i>Section Information</h6>
                              </div>
                              <div className="card-body">
                                <div className="row align-items-center">
                                  <div className="col-md-8">
                                    <label className="form-label fw-bold">Section ID <span className="text-danger">*</span></label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter section ID (required for approval)"
                                      required
                                      value={sectionIdInput}
                                      onChange={(e) => setSectionIdInput(e.target.value)}
                                    />
                                    <small className="text-muted">
                                      Please enter the section ID before approving or rejecting this video.
                                    </small>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="alert alert-info mb-0">
                                      <i className="fas fa-info-circle me-2"></i>
                                      Section ID is required for tracking and organization purposes.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Approval Section - Only show for user_type === "0" or "6" (admin/client_admin), onboarding_status === 0, AND subject_type === "2" */}
                        {(user?.user_type === "0" || user?.user_type === "6") && currentVideoItem?.onboarding_status === 0 && (
                          <div className="mt-4">
                            <div className="card border-0 shadow-sm">
                              <div className="card-header bg-light">
                                <h6 className="mb-0"><i className="fas fa-clipboard-list me-2"></i>Video Approval</h6>
                              </div>
                              <div className="card-body">
                                <div className="row align-items-center">
                                  <div className="col-md-8">
                                    <p className="text-muted mb-0">
                                      <i className="fas fa-lightbulb me-2 text-warning"></i>
                                      Review the video carefully before making a decision. Ensure:
                                    </p>
                                    <ul className="text-muted small mt-2 mb-0">
                                      <li>Face is clearly visible throughout the video</li>
                                      <li>Video quality is good (not blurry or dark)</li>
                                      <li>Person is facing the camera directly</li>
                                      <li>Video duration is appropriate (5-15 seconds recommended)</li>
                                    </ul>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="d-flex flex-column gap-2">
                                      <button
                                        className="btn btn-success btn-lg d-flex align-items-center justify-content-center"
                                        onClick={() => handleVideoApproval('accept')}
                                        disabled={isApprovalLoading || (!sectionIdInput.trim() && currentVideoItem?.subject_type === "2")}
                                        style={{ minHeight: '50px' }}
                                      >
                                        {isApprovalLoading ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Processing...
                                          </>
                                        ) : (
                                          <>
                                            <i className="fas fa-check-circle me-2 fs-5"></i>
                                            Approve Video
                                          </>
                                        )}
                                      </button>

                                      <button
                                        className="btn btn-outline-danger btn-lg d-flex align-items-center justify-content-center"
                                        onClick={() => handleRejectClick()}
                                        disabled={isApprovalLoading}
                                        style={{ minHeight: '50px' }}
                                      >
                                        <i className="fas fa-times-circle me-2 fs-5"></i>
                                        Reject Video
                                      </button>
                                    </div>
                                    {!sectionIdInput.trim() && currentVideoItem?.subject_type === "2" && (
                                      <small className="text-danger mt-2 d-block">
                                        <i className="fas fa-exclamation-triangle me-1"></i>
                                        Please enter Section ID to proceed
                                      </small>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="modal-footer bg-light">
                        <div className="row w-100 align-items-center">
                          <div className="col-md-6">
                            <small className="text-muted">
                              <i className="fas fa-id-badge me-1"></i>
                              Member ID: <span className="fw-bold">{selectedMemberId}</span>
                            </small>
                          </div>
                          <div className="col-md-6 text-end">
                            <small className={`badge ${currentVideoItem?.onboarding_status === 0
                              ? 'bg-warning'
                              : currentVideoItem?.onboarding_status === 1
                                ? 'bg-danger'
                                : 'bg-success'
                              } px-3 py-2`}>
                              <i className="fas fa-circle me-1" style={{ fontSize: '0.6rem' }}></i>
                              {
                                currentVideoItem?.onboarding_status === 0
                                  ? "Pending Approval"
                                  : currentVideoItem?.onboarding_status === 1
                                    ? "Rejected"
                                    : "Approved"
                              }
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="card-footer text-muted">
              <div className="row">
                <div className="col-md-6">
                  <small>Member ID: {selectedMemberId}</small>
                </div>
                <div className="col-md-6 text-end">
                  <small>Status: {
                    currentVideoItem?.onboarding_status === 0
                      ? "Pending Approval"
                      : currentVideoItem?.onboarding_status === 1
                        ? "Rejected"
                        : "Accepted"
                  }</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {showRejectModal && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1070
        }}>
          <div className="modal-content card" style={{
            width: '600px',
            maxWidth: '95vw',
            position: 'relative'
          }}>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Reject Video - {currentVideoItem?.name}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowRejectModal(false);
                  setSectionIdInput('');
                  setRejectRemarks('');
                }}
                disabled={isApprovalLoading}
              ></button>
            </div>

            <div className="card-body">
              {/* Person Info */}
              <div className="mb-4">
                <div className="row">
                  <div className="col-6">
                    <small className="text-muted">Course:</small>
                    <div className="fw-bold">{currentVideoItem?.course_name || 'N/A'}</div>
                  </div>
                  <div className="col-6">
                    <small className="text-muted">Department:</small>
                    <div className="fw-bold">{currentVideoItem?.department_name || 'N/A'}</div>
                  </div>
                </div>
              </div>

              {/* Section ID Input - Only show if subject_type === "2" */}
              {currentVideoItem?.subject_type === "2" && (
                <div className="mb-3">
                  <label className="form-label">Section ID <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter section ID (required for rejection)"
                    required
                    value={sectionIdInput}
                    onChange={(e) => setSectionIdInput(e.target.value)}
                  />
                  <small className="text-muted">
                    Section ID is required for tracking purposes.
                  </small>
                </div>
              )}

              {/* Rejection Remarks */}
              <div className="mb-3">
                <label className="form-label">Rejection Remarks <span className="text-danger">*</span></label>
                <textarea
                  className="form-control"
                  value={rejectRemarks}
                  onChange={(e) => setRejectRemarks(e.target.value)}
                  placeholder="Please provide the reason for rejection. This feedback will be visible to the person who uploaded the video..."
                  rows="4"
                  disabled={isApprovalLoading}
                  required
                />
                <small className="text-muted">
                  This feedback will help the person understand what needs to be improved in the video.
                </small>
              </div>

              <div className="alert alert-warning">
                <i className="fas fa-exclamation-triangle me-2"></i>
                <strong>Note:</strong> Once rejected, the person will need to re-upload a new video with improvements.
              </div>
            </div>

            <div className="card-footer d-flex justify-content-end gap-2">
              <button
                className="btn btn-outline-secondary"
                onClick={() => {
                  setShowRejectModal(false);
                  setSectionIdInput('');
                  setRejectRemarks('');
                }}
                disabled={isApprovalLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger"
                onClick={handleRejectSubmit}
                disabled={isApprovalLoading || !rejectRemarks.trim() || (currentVideoItem?.subject_type === "2" && !sectionIdInput.trim())}
              >
                {isApprovalLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Submitting...
                  </>
                ) : (
                  <>
                    <i className="fas fa-times-circle me-2"></i>
                    Submit Rejection
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}